// convert GPA to 3 decimal points
function formatGPA(gpa) {
    //var gpa = 0.0005;
    var sgpa = "" + gpa;
    return sgpa.substring(0, 5);
}

// return grade point of a letter grade
function gradePoint(grade) {
    if (grade === "A") {
        return 4;
    } else if (grade === "B") {
        return 3;
    } else if (grade === "C") {
        return 2;
    } else if (grade === "D") {
        return 1;
    } else {
        return 0;
    }
}

// validate the form entries
function validateEntries(theForm) {
    var num = theForm.semAttempted.value;
    if (num === "" || isNaN(parseFloat(num))) {
        alert("Enter a number in Semester Hrs Attempted.");
        return false;
    }
    var num = theForm.semPassed.value;
    if (num === "" || isNaN(parseFloat(num))) {
        alert("Enter a number in Semester Hrs Passed.");
        return false;
    }
    var num = theForm.totQPts.value;
    if (num === "" || isNaN(parseFloat(num))) {
        alert("Enter a number in Total Quality Points.");
        return false;
    }
    for (i = 1; i < 13; i++) {
        hrs = theForm.elements["hrsAttempted" + i].value;
        if (hrs !== "" && isNaN(parseFloat(hrs))) {
            alert("Enter a valid number for Hours Attempted in row " + i);
            return false;
        }
    }
    return true;
}

// main function -- compute all values in form
function compute(theForm) {
    if (!validateEntries(theForm)) {
        return;
    }

    // initialize variables
    var semHrsAttempted = 0;
    var semHrsPassed = 0;
    var semQualityPoints = 0;
    var cumHrsAttempted = parseFloat(theForm.semAttempted.value);
    var cumHrsPassed = parseFloat(theForm.semPassed.value);
    var cumQualityPoints = parseFloat(theForm.totQPts.value);

    // compute the cumulative GPA and display in 3 decimal points
    theForm.cumGPA.value = formatGPA(cumQualityPoints / cumHrsAttempted);

    // compute projected course quality points
    for (i = 1; i < 13; i++) {
        grade =
            theForm.elements["grade" + i][
                theForm.elements["grade" + i].selectedIndex
            ].text;
        hrs = theForm.elements["hrsAttempted" + i].value;
        if (grade !== "" && hrs !== "0") {
            hrs = parseFloat(hrs);
            // WP and IC hours not counted
            if (grade == "WP" || grade == "IC") {
                hrs = 0;
            }
            points = gradePoint(grade);
            semHrsAttempted = semHrsAttempted + hrs;
            cumHrsAttempted += hrs;
            if (points > 0) {
                theForm.elements["hrsPassed" + i].value = hrs;
                qpoints = points * hrs;
                theForm.elements["qpoints" + i].value = qpoints;
                semHrsPassed += hrs;
                semQualityPoints += qpoints;
                cumHrsPassed += hrs;
                cumQualityPoints += qpoints;
                // remove repeated course hours and quality points
                rptgrade =
                    theForm.elements["rptcourse" + i][
                        theForm.elements["rptcourse" + i].selectedIndex
                    ].text;
                if (rptgrade !== "") {
                    rptpts = gradePoint(rptgrade);
                    cumHrsAttempted -= hrs; // remove repeated course attempted hours
                    if (rptpts > 0) {
                        cumHrsPassed -= hrs; // remove repeated course passed hours
                        cumQualityPoints -= rptpts * hrs; // remove repeated course quality points
                    }
                }
            } else {
                theForm.elements["hrsPassed" + i].value = 0;
                theForm.elements["qpoints" + i].value = 0;
            }
        }
    }
    theForm.semHrsAttempted.value = semHrsAttempted;
    theForm.semHrsPassed.value = semHrsPassed;
    theForm.semQPoints.value = semQualityPoints;
    theForm.cumHrsAttempted.value = cumHrsAttempted;
    theForm.cumHrsPassed.value = cumHrsPassed;
    theForm.cumQPoints.value = cumQualityPoints;
    theForm.projSemGPA.value = formatGPA(semQualityPoints / semHrsAttempted);
    theForm.projCumGPA.value = formatGPA(cumQualityPoints / cumHrsAttempted);
}

// wire up the Calculate button rendered by the gpa_calculator shortcodes.
// The form spans two shortcodes, so page markup can leave the button owned
// by the form but outside it in the DOM; button.form resolves either way.
function setup() {
    document
        .querySelectorAll(".gpa-calculator__calculate")
        .forEach(function (button) {
            if (button.form) {
                button.addEventListener("click", function () {
                    compute(button.form);
                });
            }
        });
}

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup);
} else {
    setup();
}
